interface PriceBenefits {
  exceptionPaymentEventBenefitPrice: number;
  maximumBenefitPrice: number;
  maximumBenefitDiscountRate: number;
}

interface Credits {
  point: number;
  mileage: number;
}

interface BenefitState {
  priceBenefits: PriceBenefits;
  credits: Credits;
  userClick: boolean;
  checkedMaxCoupon: boolean;
  checkedDuplicationCoupon: boolean;
  checkedPoint: boolean;
  checkedMileage: boolean;
  checkedListPaymentEvent: boolean[];
}

type BenefitAction =
  | { type: 'SET_PRICE_BENEFITS'; payload: PriceBenefits }
  | { type: 'SET_CREDITS'; payload: Credits }
  | { type: 'SET_CHECKED_MAX_COUPON'; payload: boolean }
  | { type: 'SET_CHECKED_DUPLICATION_COUPON'; payload: boolean }
  | { type: 'SET_CHECKED_POINT'; payload: boolean }
  | { type: 'SET_CHECKED_MILEAGE'; payload: boolean }
  | { type: 'SET_CHECKED_PAYMENT_EVENT'; payload: boolean[] }
  | { type: 'CLICK_MAX_COUPON'; payload: boolean }
  | { type: 'CLICK_DUPLICATION_COUPON'; payload: boolean }
  | { type: 'CLICK_POINT'; payload: boolean }
  | { type: 'CLICK_MILEAGE'; payload: boolean }
  | { type: 'CLICK_PAYMENT_EVENT'; payload: boolean[] };

/**
 * 혜택 계산을 관리하기 위한 리듀서
 * @param {Object} state - 현재 상태
 * @param {Object} action - 수행할 액션
 * @returns {Object} - 새 상태
 */
export const benefitReducer = (state: BenefitState, action: BenefitAction): BenefitState => {
  switch (action.type) {
    case 'SET_PRICE_BENEFITS':
      return {
        ...state,
        priceBenefits: action.payload,
      };
    case 'SET_CREDITS':
      return {
        ...state,
        credits: action.payload,
      };
    case 'SET_CHECKED_MAX_COUPON':
      return {
        ...state,
        checkedMaxCoupon: action.payload,
      };
    case 'SET_CHECKED_DUPLICATION_COUPON':
      return {
        ...state,
        checkedDuplicationCoupon: action.payload,
      };
    case 'SET_CHECKED_POINT':
      return {
        ...state,
        checkedPoint: action.payload,
      };
    case 'SET_CHECKED_MILEAGE':
      return {
        ...state,
        checkedMileage: action.payload,
      };
    case 'SET_CHECKED_PAYMENT_EVENT':
      return {
        ...state,
        checkedListPaymentEvent: action.payload,
      };
    case 'CLICK_MAX_COUPON':
      return {
        ...state,
        checkedMaxCoupon: action.payload,
        userClick: true,
      };
    case 'CLICK_DUPLICATION_COUPON':
      return {
        ...state,
        checkedDuplicationCoupon: action.payload,
        userClick: true,
      };
    case 'CLICK_POINT':
      return {
        ...state,
        checkedPoint: action.payload,
        userClick: true,
      };
    case 'CLICK_MILEAGE':
      return {
        ...state,
        checkedMileage: action.payload,
        userClick: true,
      };
    case 'CLICK_PAYMENT_EVENT':
      return {
        ...state,
        checkedListPaymentEvent: action.payload,
        userClick: true,
      };
    default:
      return state;
  }
};

export const initialBenefitState: BenefitState = {
  priceBenefits: {
    exceptionPaymentEventBenefitPrice: 0,
    maximumBenefitPrice: 0,
    maximumBenefitDiscountRate: 0,
  },
  credits: {
    point: 0,
    mileage: 0,
  },
  userClick: false,
  checkedMaxCoupon: true,
  checkedDuplicationCoupon: true,
  checkedPoint: true,
  checkedMileage: true,
  checkedListPaymentEvent: [],
};
